import {BrowserModule} from '@angular/platform-browser';
import {APP_INITIALIZER, ErrorHandler, NgModule} from '@angular/core';
import {App, IonicApp, IonicErrorHandler, IonicModule, Platform} from 'ionic-angular';
import {SplashScreen} from '@ionic-native/splash-screen';
import {StatusBar} from '@ionic-native/status-bar';
import {EkipeaApp} from './app.component';
import {LoginPageModule} from '../pages/login/login.module';
import {BlogArticleListPageModule} from '../pages/blog-article-list/blog-article-list.module';
import {OauthService} from '../shared/services/oauth.service';
import {BeneficiaireListPageModule} from '../pages/beneficiaire-list/beneficiaire-list.module';
import {UserBoardPageModule} from '../pages/user-board/user-board.module';
import {Http, HttpModule, RequestOptions, XHRBackend} from '@angular/http';
// Notice it is imported from @angular/common/http instead of @angular/http
import {HttpClientModule} from '@angular/common/http';
import {CoreModule} from '../core';
import {CartService} from '../shared/services/cart.service';
import {ToastDirective} from '../shared/directives/toast/toast';
import {CeService} from '../shared/services/ce.service';
import {UserService} from '../shared/services/user.service';
import {ImagesService} from '../shared/services/images.service';
import {HttpInterceptorService} from '../shared/services/httpInterceptor.service';
import {LocalStorageService} from '../shared/services/localStorage.service';
import {SessionStorageService} from '../shared/services/sessionStorage.service';
import {ModelService} from '../shared/services/model.service';
import {SharedModule} from '../shared';
import {PlatformContextDirective} from '../shared/directives/platform-context/platform-context';
import {LoadingService} from '../shared/services/loading.service';
import {EnvironnementInitializer} from '../core/app/environnement-initializer.service';
import {EnvironnementRequiredService} from '../core/app/environnement-required.service';
import {ToolsService} from '../shared/services/tools.service';
import {Config} from '../shared/services/config.service';
import { UserTempPageModule } from '../pages/user-temp/user-temp.module';
import { NgxMaskIonicModule } from 'ngx-mask-ionic';
import { MenuService } from '../shared/services/menu.service';
import { UpdateAppService } from "../shared/services/update-app.service";

@NgModule({
  declarations: [
    EkipeaApp,
    ToastDirective
  ],
  imports: [
    SharedModule,
    BrowserModule,
    IonicModule.forRoot(EkipeaApp, {
      menuType: 'overlay',
      backButtonText: '',
      iconMode: 'md',
      backButtonIcon: 'ios-arrow-back',
      statusbarPadding: true
    }),
    LoginPageModule,
    BeneficiaireListPageModule,
    BlogArticleListPageModule,
    UserBoardPageModule,
    UserTempPageModule,
    HttpModule,
    CoreModule,
    HttpClientModule,
    NgxMaskIonicModule.forRoot()
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    EkipeaApp
  ],
  providers: [
    EnvironnementInitializer,
    EnvironnementRequiredService,
    StatusBar,
    SplashScreen,
    OauthService,
    CartService,
    ToastDirective,
    PlatformContextDirective,
    Config,
    CeService,
    ImagesService,
    UserService,
    LocalStorageService,
    SessionStorageService,
    LoadingService,
    MenuService,
    UpdateAppService,
    {
      provide: APP_INITIALIZER,
      useFactory: (environnementInitializer: EnvironnementInitializer) => {
        return () => environnementInitializer.init();
      },
      deps: [EnvironnementInitializer],
      multi: true
    },
    ModelService,
    {
      provide: Http,
      useClass: HttpInterceptorService,
      useFactory:
        (backend: XHRBackend, defaultOptions: RequestOptions, modelService: ModelService, app: App,
          loadingService: LoadingService, tools: ToolsService) => {
          return new HttpInterceptorService(backend, defaultOptions, modelService, app, loadingService, tools);
        },
      deps: [XHRBackend, RequestOptions, ModelService, App, LoadingService, ToolsService]
    },
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    ToolsService,
  ],
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts